<div class="header"><header-logo :init_gnb_design="init_gnb_design"></header-logo><header-dropdown></header-dropdown></div>